import { render, staticRenderFns } from "./2300_Wrap_Up.vue?vue&type=template&id=b3f691b8&scoped=true&lang=pug"
var script = {}
import style0 from "./2300_Wrap_Up.vue?vue&type=style&index=0&id=b3f691b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f691b8",
  null
  
)

export default component.exports